import { useEffect, useContext } from 'react'
import { navigate } from 'gatsby'
import LanguageContext from '../contexts/languageContext'
import { possibleLanguages } from '../helpers/path'

const Main = ({ location }) => {
  const params = new URLSearchParams(location?.search)
  const langFromVulcano = params.get('vlc-language')

  const { lang, setLanguage } = useContext(LanguageContext)
  useEffect(() => {
    if (possibleLanguages.includes(langFromVulcano)) setLanguage(langFromVulcano)
    const url = `/${lang}/`

    navigate(url)
  }, [lang])

  return null
}

export default Main
